export const errorMessageMap = {
  "expired_card" : "Your credit card has expired. Please delete your existing card and setup another one on My Profile page.",
  "NO_PAYMENT_SETUP" : "Please set up your credit card."
}
